export const EXTERNAL_VIDEO_PREFIX = '~~~external-video~~~';
